var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileOrnament(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 181,
    viewBox: "0 0 300 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.287 -49.2297C290.118 -47.7907 290.927 -46.3377 291.714 -44.871C290.285 -45.8058 289.33 -47.4049 289.287 -49.2297Z",
    fill: "url(#paint0_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.954 -86.2148C262.451 -83.8721 264.872 -81.4506 267.215 -78.9543C266.309 -77.28 264.537 -76.1429 262.5 -76.1429C259.541 -76.1429 257.143 -78.5413 257.143 -81.5C257.143 -83.5372 258.28 -85.3089 259.954 -86.2148Z",
    fill: "url(#paint1_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.871 -110.714C227.338 -109.927 228.791 -109.118 230.23 -108.287C228.405 -108.33 226.806 -109.285 225.871 -110.714Z",
    fill: "url(#paint2_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7703 -108.287C71.2093 -109.118 72.6623 -109.927 74.129 -110.714C73.1942 -109.285 71.5951 -108.33 69.7703 -108.287Z",
    fill: "url(#paint3_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7852 -78.9543C35.1279 -81.4506 37.5494 -83.8721 40.0457 -86.2148C41.72 -85.3089 42.8571 -83.5372 42.8571 -81.5C42.8571 -78.5413 40.4587 -76.1429 37.5 -76.1429C35.4628 -76.1429 33.6911 -77.28 32.7852 -78.9543Z",
    fill: "url(#paint4_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28625 -44.871C9.07314 -46.3377 9.88214 -47.7907 10.7128 -49.2297C10.6702 -47.4049 9.71517 -45.8058 8.28625 -44.871Z",
    fill: "url(#paint5_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.714 106.871C290.927 108.338 290.118 109.791 289.287 111.23C289.33 109.405 290.285 107.806 291.714 106.871Z",
    fill: "url(#paint6_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.215 140.954C266.309 139.28 264.537 138.143 262.5 138.143C259.541 138.143 257.143 140.541 257.143 143.5C257.143 145.537 258.28 147.309 259.954 148.215C262.451 145.872 264.872 143.451 267.215 140.954Z",
    fill: "url(#paint7_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23 170.287C228.405 170.33 226.806 171.285 225.871 172.714C227.338 171.927 228.791 171.118 230.23 170.287Z",
    fill: "url(#paint8_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.129 172.714C73.1942 171.285 71.5951 170.33 69.7703 170.287C71.2093 171.118 72.6623 171.927 74.129 172.714Z",
    fill: "url(#paint9_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0457 148.215C41.72 147.309 42.8571 145.537 42.8571 143.5C42.8571 140.541 40.4587 138.143 37.5 138.143C35.4628 138.143 33.6911 139.28 32.7852 140.954C35.1279 143.451 37.5494 145.872 40.0457 148.215Z",
    fill: "url(#paint10_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7128 111.23C10.6702 109.405 9.71517 107.806 8.28625 106.871C9.07314 108.338 9.88214 109.791 10.7128 111.23Z",
    fill: "url(#paint11_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 -113.643C107.143 -110.684 104.744 -108.286 101.786 -108.286C98.827 -108.286 96.4286 -110.684 96.4286 -113.643C96.4286 -116.602 98.827 -119 101.786 -119C104.744 -119 107.143 -116.602 107.143 -113.643Z",
    fill: "url(#paint12_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 -113.643C139.286 -110.684 136.887 -108.286 133.929 -108.286C130.97 -108.286 128.571 -110.684 128.571 -113.643C128.571 -116.602 130.97 -119 133.929 -119C136.887 -119 139.286 -116.602 139.286 -113.643Z",
    fill: "url(#paint13_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 -113.643C171.429 -110.684 169.03 -108.286 166.071 -108.286C163.113 -108.286 160.714 -110.684 160.714 -113.643C160.714 -116.602 163.113 -119 166.071 -119C169.03 -119 171.429 -116.602 171.429 -113.643Z",
    fill: "url(#paint14_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 -113.643C203.571 -110.684 201.173 -108.286 198.214 -108.286C195.256 -108.286 192.857 -110.684 192.857 -113.643C192.857 -116.602 195.256 -119 198.214 -119C201.173 -119 203.571 -116.602 203.571 -113.643Z",
    fill: "url(#paint15_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 -81.5C75 -78.5413 72.6015 -76.1429 69.6429 -76.1429C66.6842 -76.1429 64.2857 -78.5413 64.2857 -81.5C64.2857 -84.4587 66.6842 -86.8571 69.6429 -86.8571C72.6015 -86.8571 75 -84.4587 75 -81.5Z",
    fill: "url(#paint16_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 -81.5C107.143 -78.5413 104.744 -76.1429 101.786 -76.1429C98.827 -76.1429 96.4286 -78.5413 96.4286 -81.5C96.4286 -84.4587 98.827 -86.8571 101.786 -86.8571C104.744 -86.8571 107.143 -84.4587 107.143 -81.5Z",
    fill: "url(#paint17_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 -81.5C139.286 -78.5413 136.887 -76.1429 133.929 -76.1429C130.97 -76.1429 128.571 -78.5413 128.571 -81.5C128.571 -84.4587 130.97 -86.8571 133.929 -86.8571C136.887 -86.8571 139.286 -84.4587 139.286 -81.5Z",
    fill: "url(#paint18_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 -81.5C171.429 -78.5413 169.03 -76.1429 166.071 -76.1429C163.113 -76.1429 160.714 -78.5413 160.714 -81.5C160.714 -84.4587 163.113 -86.8571 166.071 -86.8571C169.03 -86.8571 171.429 -84.4587 171.429 -81.5Z",
    fill: "url(#paint19_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 -81.5C203.571 -78.5413 201.173 -76.1429 198.214 -76.1429C195.256 -76.1429 192.857 -78.5413 192.857 -81.5C192.857 -84.4587 195.256 -86.8571 198.214 -86.8571C201.173 -86.8571 203.571 -84.4587 203.571 -81.5Z",
    fill: "url(#paint20_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 -81.5C235.714 -78.5413 233.316 -76.1429 230.357 -76.1429C227.398 -76.1429 225 -78.5413 225 -81.5C225 -84.4587 227.398 -86.8571 230.357 -86.8571C233.316 -86.8571 235.714 -84.4587 235.714 -81.5Z",
    fill: "url(#paint21_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 -49.3571C42.8571 -46.3985 40.4587 -44 37.5 -44C34.5413 -44 32.1429 -46.3985 32.1429 -49.3571C32.1429 -52.3158 34.5413 -54.7143 37.5 -54.7143C40.4587 -54.7143 42.8571 -52.3158 42.8571 -49.3571Z",
    fill: "url(#paint22_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 -49.3571C75 -46.3985 72.6015 -44 69.6429 -44C66.6842 -44 64.2857 -46.3985 64.2857 -49.3571C64.2857 -52.3158 66.6842 -54.7143 69.6429 -54.7143C72.6015 -54.7143 75 -52.3158 75 -49.3571Z",
    fill: "url(#paint23_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 -49.3571C107.143 -46.3985 104.744 -44 101.786 -44C98.827 -44 96.4286 -46.3985 96.4286 -49.3571C96.4286 -52.3158 98.827 -54.7143 101.786 -54.7143C104.744 -54.7143 107.143 -52.3158 107.143 -49.3571Z",
    fill: "url(#paint24_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 -49.3571C139.286 -46.3985 136.887 -44 133.929 -44C130.97 -44 128.571 -46.3985 128.571 -49.3571C128.571 -52.3158 130.97 -54.7143 133.929 -54.7143C136.887 -54.7143 139.286 -52.3158 139.286 -49.3571Z",
    fill: "url(#paint25_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 -49.3571C171.429 -46.3985 169.03 -44 166.071 -44C163.113 -44 160.714 -46.3985 160.714 -49.3571C160.714 -52.3158 163.113 -54.7143 166.071 -54.7143C169.03 -54.7143 171.429 -52.3158 171.429 -49.3571Z",
    fill: "url(#paint26_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 -49.3571C203.571 -46.3985 201.173 -44 198.214 -44C195.256 -44 192.857 -46.3985 192.857 -49.3571C192.857 -52.3158 195.256 -54.7143 198.214 -54.7143C201.173 -54.7143 203.571 -52.3158 203.571 -49.3571Z",
    fill: "url(#paint27_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 -49.3571C235.714 -46.3985 233.316 -44 230.357 -44C227.398 -44 225 -46.3985 225 -49.3571C225 -52.3158 227.398 -54.7143 230.357 -54.7143C233.316 -54.7143 235.714 -52.3158 235.714 -49.3571Z",
    fill: "url(#paint28_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.857 -49.3571C267.857 -46.3985 265.459 -44 262.5 -44C259.541 -44 257.143 -46.3985 257.143 -49.3571C257.143 -52.3158 259.541 -54.7143 262.5 -54.7143C265.459 -54.7143 267.857 -52.3158 267.857 -49.3571Z",
    fill: "url(#paint29_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 -17.2143C10.7143 -14.2556 8.31581 -11.8571 5.35714 -11.8571C2.39847 -11.8571 0 -14.2556 0 -17.2143C0 -20.173 2.39847 -22.5714 5.35714 -22.5714C8.31581 -22.5714 10.7143 -20.173 10.7143 -17.2143Z",
    fill: "url(#paint30_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 -17.2143C42.8571 -14.2556 40.4587 -11.8571 37.5 -11.8571C34.5413 -11.8571 32.1429 -14.2556 32.1429 -17.2143C32.1429 -20.173 34.5413 -22.5714 37.5 -22.5714C40.4587 -22.5714 42.8571 -20.173 42.8571 -17.2143Z",
    fill: "url(#paint31_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 -17.2143C75 -14.2556 72.6015 -11.8571 69.6429 -11.8571C66.6842 -11.8571 64.2857 -14.2556 64.2857 -17.2143C64.2857 -20.173 66.6842 -22.5714 69.6429 -22.5714C72.6015 -22.5714 75 -20.173 75 -17.2143Z",
    fill: "url(#paint32_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 -17.2143C107.143 -14.2556 104.744 -11.8571 101.786 -11.8571C98.827 -11.8571 96.4286 -14.2556 96.4286 -17.2143C96.4286 -20.173 98.827 -22.5714 101.786 -22.5714C104.744 -22.5714 107.143 -20.173 107.143 -17.2143Z",
    fill: "url(#paint33_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 -17.2143C139.286 -14.2556 136.887 -11.8571 133.929 -11.8571C130.97 -11.8571 128.571 -14.2556 128.571 -17.2143C128.571 -20.173 130.97 -22.5714 133.929 -22.5714C136.887 -22.5714 139.286 -20.173 139.286 -17.2143Z",
    fill: "url(#paint34_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 -17.2143C171.429 -14.2556 169.03 -11.8571 166.071 -11.8571C163.113 -11.8571 160.714 -14.2556 160.714 -17.2143C160.714 -20.173 163.113 -22.5714 166.071 -22.5714C169.03 -22.5714 171.429 -20.173 171.429 -17.2143Z",
    fill: "url(#paint35_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 -17.2143C203.571 -14.2556 201.173 -11.8571 198.214 -11.8571C195.256 -11.8571 192.857 -14.2556 192.857 -17.2143C192.857 -20.173 195.256 -22.5714 198.214 -22.5714C201.173 -22.5714 203.571 -20.173 203.571 -17.2143Z",
    fill: "url(#paint36_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 -17.2143C235.714 -14.2556 233.316 -11.8571 230.357 -11.8571C227.398 -11.8571 225 -14.2556 225 -17.2143C225 -20.173 227.398 -22.5714 230.357 -22.5714C233.316 -22.5714 235.714 -20.173 235.714 -17.2143Z",
    fill: "url(#paint37_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.857 -17.2143C267.857 -14.2556 265.459 -11.8571 262.5 -11.8571C259.541 -11.8571 257.143 -14.2556 257.143 -17.2143C257.143 -20.173 259.541 -22.5714 262.5 -22.5714C265.459 -22.5714 267.857 -20.173 267.857 -17.2143Z",
    fill: "url(#paint38_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 -17.2143C300 -14.2556 297.602 -11.8571 294.643 -11.8571C291.684 -11.8571 289.286 -14.2556 289.286 -17.2143C289.286 -20.173 291.684 -22.5714 294.643 -22.5714C297.602 -22.5714 300 -20.173 300 -17.2143Z",
    fill: "url(#paint39_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 14.9286C10.7143 17.8872 8.31581 20.2857 5.35714 20.2857C2.39847 20.2857 0 17.8872 0 14.9286C0 11.9699 2.39847 9.57143 5.35714 9.57143C8.31581 9.57143 10.7143 11.9699 10.7143 14.9286Z",
    fill: "url(#paint40_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 14.9286C42.8571 17.8872 40.4587 20.2857 37.5 20.2857C34.5413 20.2857 32.1429 17.8872 32.1429 14.9286C32.1429 11.9699 34.5413 9.57143 37.5 9.57143C40.4587 9.57143 42.8571 11.9699 42.8571 14.9286Z",
    fill: "url(#paint41_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 14.9286C75 17.8872 72.6015 20.2857 69.6429 20.2857C66.6842 20.2857 64.2857 17.8872 64.2857 14.9286C64.2857 11.9699 66.6842 9.57143 69.6429 9.57143C72.6015 9.57143 75 11.9699 75 14.9286Z",
    fill: "url(#paint42_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 14.9286C107.143 17.8872 104.744 20.2857 101.786 20.2857C98.827 20.2857 96.4286 17.8872 96.4286 14.9286C96.4286 11.9699 98.827 9.57143 101.786 9.57143C104.744 9.57143 107.143 11.9699 107.143 14.9286Z",
    fill: "url(#paint43_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 14.9286C139.286 17.8872 136.887 20.2857 133.929 20.2857C130.97 20.2857 128.571 17.8872 128.571 14.9286C128.571 11.9699 130.97 9.57143 133.929 9.57143C136.887 9.57143 139.286 11.9699 139.286 14.9286Z",
    fill: "url(#paint44_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 14.9286C171.429 17.8872 169.03 20.2857 166.071 20.2857C163.113 20.2857 160.714 17.8872 160.714 14.9286C160.714 11.9699 163.113 9.57143 166.071 9.57143C169.03 9.57143 171.429 11.9699 171.429 14.9286Z",
    fill: "url(#paint45_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 14.9286C203.571 17.8872 201.173 20.2857 198.214 20.2857C195.256 20.2857 192.857 17.8872 192.857 14.9286C192.857 11.9699 195.256 9.57143 198.214 9.57143C201.173 9.57143 203.571 11.9699 203.571 14.9286Z",
    fill: "url(#paint46_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 14.9286C235.714 17.8872 233.316 20.2857 230.357 20.2857C227.398 20.2857 225 17.8872 225 14.9286C225 11.9699 227.398 9.57143 230.357 9.57143C233.316 9.57143 235.714 11.9699 235.714 14.9286Z",
    fill: "url(#paint47_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.857 14.9286C267.857 17.8872 265.459 20.2857 262.5 20.2857C259.541 20.2857 257.143 17.8872 257.143 14.9286C257.143 11.9699 259.541 9.57143 262.5 9.57143C265.459 9.57143 267.857 11.9699 267.857 14.9286Z",
    fill: "url(#paint48_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 14.9286C300 17.8872 297.602 20.2857 294.643 20.2857C291.684 20.2857 289.286 17.8872 289.286 14.9286C289.286 11.9699 291.684 9.57143 294.643 9.57143C297.602 9.57143 300 11.9699 300 14.9286Z",
    fill: "url(#paint49_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 47.0714C10.7143 50.0301 8.31581 52.4286 5.35714 52.4286C2.39847 52.4286 0 50.0301 0 47.0714C0 44.1128 2.39847 41.7143 5.35714 41.7143C8.31581 41.7143 10.7143 44.1128 10.7143 47.0714Z",
    fill: "url(#paint50_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 47.0714C42.8571 50.0301 40.4587 52.4286 37.5 52.4286C34.5413 52.4286 32.1429 50.0301 32.1429 47.0714C32.1429 44.1128 34.5413 41.7143 37.5 41.7143C40.4587 41.7143 42.8571 44.1128 42.8571 47.0714Z",
    fill: "url(#paint51_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 47.0714C75 50.0301 72.6015 52.4286 69.6429 52.4286C66.6842 52.4286 64.2857 50.0301 64.2857 47.0714C64.2857 44.1128 66.6842 41.7143 69.6429 41.7143C72.6015 41.7143 75 44.1128 75 47.0714Z",
    fill: "url(#paint52_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 47.0714C107.143 50.0301 104.744 52.4286 101.786 52.4286C98.827 52.4286 96.4286 50.0301 96.4286 47.0714C96.4286 44.1128 98.827 41.7143 101.786 41.7143C104.744 41.7143 107.143 44.1128 107.143 47.0714Z",
    fill: "url(#paint53_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 47.0714C139.286 50.0301 136.887 52.4286 133.929 52.4286C130.97 52.4286 128.571 50.0301 128.571 47.0714C128.571 44.1128 130.97 41.7143 133.929 41.7143C136.887 41.7143 139.286 44.1128 139.286 47.0714Z",
    fill: "url(#paint54_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 47.0714C171.429 50.0301 169.03 52.4286 166.071 52.4286C163.113 52.4286 160.714 50.0301 160.714 47.0714C160.714 44.1128 163.113 41.7143 166.071 41.7143C169.03 41.7143 171.429 44.1128 171.429 47.0714Z",
    fill: "url(#paint55_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 47.0714C203.571 50.0301 201.173 52.4286 198.214 52.4286C195.256 52.4286 192.857 50.0301 192.857 47.0714C192.857 44.1128 195.256 41.7143 198.214 41.7143C201.173 41.7143 203.571 44.1128 203.571 47.0714Z",
    fill: "url(#paint56_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 47.0714C235.714 50.0301 233.316 52.4286 230.357 52.4286C227.398 52.4286 225 50.0301 225 47.0714C225 44.1128 227.398 41.7143 230.357 41.7143C233.316 41.7143 235.714 44.1128 235.714 47.0714Z",
    fill: "url(#paint57_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.857 47.0714C267.857 50.0301 265.459 52.4286 262.5 52.4286C259.541 52.4286 257.143 50.0301 257.143 47.0714C257.143 44.1128 259.541 41.7143 262.5 41.7143C265.459 41.7143 267.857 44.1128 267.857 47.0714Z",
    fill: "url(#paint58_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 47.0714C300 50.0301 297.602 52.4286 294.643 52.4286C291.684 52.4286 289.286 50.0301 289.286 47.0714C289.286 44.1128 291.684 41.7143 294.643 41.7143C297.602 41.7143 300 44.1128 300 47.0714Z",
    fill: "url(#paint59_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 79.2143C10.7143 82.173 8.31581 84.5714 5.35714 84.5714C2.39847 84.5714 0 82.173 0 79.2143C0 76.2556 2.39847 73.8571 5.35714 73.8571C8.31581 73.8571 10.7143 76.2556 10.7143 79.2143Z",
    fill: "url(#paint60_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 79.2143C42.8571 82.173 40.4587 84.5714 37.5 84.5714C34.5413 84.5714 32.1429 82.173 32.1429 79.2143C32.1429 76.2556 34.5413 73.8571 37.5 73.8571C40.4587 73.8571 42.8571 76.2556 42.8571 79.2143Z",
    fill: "url(#paint61_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 79.2143C75 82.173 72.6015 84.5714 69.6429 84.5714C66.6842 84.5714 64.2857 82.173 64.2857 79.2143C64.2857 76.2556 66.6842 73.8571 69.6429 73.8571C72.6015 73.8571 75 76.2556 75 79.2143Z",
    fill: "url(#paint62_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 79.2143C107.143 82.173 104.744 84.5714 101.786 84.5714C98.827 84.5714 96.4286 82.173 96.4286 79.2143C96.4286 76.2556 98.827 73.8571 101.786 73.8571C104.744 73.8571 107.143 76.2556 107.143 79.2143Z",
    fill: "url(#paint63_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 79.2143C139.286 82.173 136.887 84.5714 133.929 84.5714C130.97 84.5714 128.571 82.173 128.571 79.2143C128.571 76.2556 130.97 73.8571 133.929 73.8571C136.887 73.8571 139.286 76.2556 139.286 79.2143Z",
    fill: "url(#paint64_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 79.2143C171.429 82.173 169.03 84.5714 166.071 84.5714C163.113 84.5714 160.714 82.173 160.714 79.2143C160.714 76.2556 163.113 73.8571 166.071 73.8571C169.03 73.8571 171.429 76.2556 171.429 79.2143Z",
    fill: "url(#paint65_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 79.2143C203.571 82.173 201.173 84.5714 198.214 84.5714C195.256 84.5714 192.857 82.173 192.857 79.2143C192.857 76.2556 195.256 73.8571 198.214 73.8571C201.173 73.8571 203.571 76.2556 203.571 79.2143Z",
    fill: "url(#paint66_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 79.2143C235.714 82.173 233.316 84.5714 230.357 84.5714C227.398 84.5714 225 82.173 225 79.2143C225 76.2556 227.398 73.8571 230.357 73.8571C233.316 73.8571 235.714 76.2556 235.714 79.2143Z",
    fill: "url(#paint67_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.857 79.2143C267.857 82.173 265.459 84.5714 262.5 84.5714C259.541 84.5714 257.143 82.173 257.143 79.2143C257.143 76.2556 259.541 73.8571 262.5 73.8571C265.459 73.8571 267.857 76.2556 267.857 79.2143Z",
    fill: "url(#paint68_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 79.2143C300 82.173 297.602 84.5714 294.643 84.5714C291.684 84.5714 289.286 82.173 289.286 79.2143C289.286 76.2556 291.684 73.8571 294.643 73.8571C297.602 73.8571 300 76.2556 300 79.2143Z",
    fill: "url(#paint69_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 111.357C42.8571 114.316 40.4587 116.714 37.5 116.714C34.5413 116.714 32.1429 114.316 32.1429 111.357C32.1429 108.398 34.5413 106 37.5 106C40.4587 106 42.8571 108.398 42.8571 111.357Z",
    fill: "url(#paint70_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 111.357C75 114.316 72.6015 116.714 69.6429 116.714C66.6842 116.714 64.2857 114.316 64.2857 111.357C64.2857 108.398 66.6842 106 69.6429 106C72.6015 106 75 108.398 75 111.357Z",
    fill: "url(#paint71_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 111.357C107.143 114.316 104.744 116.714 101.786 116.714C98.827 116.714 96.4286 114.316 96.4286 111.357C96.4286 108.398 98.827 106 101.786 106C104.744 106 107.143 108.398 107.143 111.357Z",
    fill: "url(#paint72_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 111.357C139.286 114.316 136.887 116.714 133.929 116.714C130.97 116.714 128.571 114.316 128.571 111.357C128.571 108.398 130.97 106 133.929 106C136.887 106 139.286 108.398 139.286 111.357Z",
    fill: "url(#paint73_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 111.357C171.429 114.316 169.03 116.714 166.071 116.714C163.113 116.714 160.714 114.316 160.714 111.357C160.714 108.398 163.113 106 166.071 106C169.03 106 171.429 108.398 171.429 111.357Z",
    fill: "url(#paint74_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 111.357C203.571 114.316 201.173 116.714 198.214 116.714C195.256 116.714 192.857 114.316 192.857 111.357C192.857 108.398 195.256 106 198.214 106C201.173 106 203.571 108.398 203.571 111.357Z",
    fill: "url(#paint75_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 111.357C235.714 114.316 233.316 116.714 230.357 116.714C227.398 116.714 225 114.316 225 111.357C225 108.398 227.398 106 230.357 106C233.316 106 235.714 108.398 235.714 111.357Z",
    fill: "url(#paint76_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.857 111.357C267.857 114.316 265.459 116.714 262.5 116.714C259.541 116.714 257.143 114.316 257.143 111.357C257.143 108.398 259.541 106 262.5 106C265.459 106 267.857 108.398 267.857 111.357Z",
    fill: "url(#paint77_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 143.5C75 146.459 72.6015 148.857 69.6429 148.857C66.6842 148.857 64.2857 146.459 64.2857 143.5C64.2857 140.541 66.6842 138.143 69.6429 138.143C72.6015 138.143 75 140.541 75 143.5Z",
    fill: "url(#paint78_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 143.5C107.143 146.459 104.744 148.857 101.786 148.857C98.827 148.857 96.4286 146.459 96.4286 143.5C96.4286 140.541 98.827 138.143 101.786 138.143C104.744 138.143 107.143 140.541 107.143 143.5Z",
    fill: "url(#paint79_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 143.5C139.286 146.459 136.887 148.857 133.929 148.857C130.97 148.857 128.571 146.459 128.571 143.5C128.571 140.541 130.97 138.143 133.929 138.143C136.887 138.143 139.286 140.541 139.286 143.5Z",
    fill: "url(#paint80_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 143.5C171.429 146.459 169.03 148.857 166.071 148.857C163.113 148.857 160.714 146.459 160.714 143.5C160.714 140.541 163.113 138.143 166.071 138.143C169.03 138.143 171.429 140.541 171.429 143.5Z",
    fill: "url(#paint81_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 143.5C203.571 146.459 201.173 148.857 198.214 148.857C195.256 148.857 192.857 146.459 192.857 143.5C192.857 140.541 195.256 138.143 198.214 138.143C201.173 138.143 203.571 140.541 203.571 143.5Z",
    fill: "url(#paint82_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.714 143.5C235.714 146.459 233.316 148.857 230.357 148.857C227.398 148.857 225 146.459 225 143.5C225 140.541 227.398 138.143 230.357 138.143C233.316 138.143 235.714 140.541 235.714 143.5Z",
    fill: "url(#paint83_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 175.643C107.143 178.602 104.744 181 101.786 181C98.827 181 96.4286 178.602 96.4286 175.643C96.4286 172.684 98.827 170.286 101.786 170.286C104.744 170.286 107.143 172.684 107.143 175.643Z",
    fill: "url(#paint84_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 175.643C139.286 178.602 136.887 181 133.929 181C130.97 181 128.571 178.602 128.571 175.643C128.571 172.684 130.97 170.286 133.929 170.286C136.887 170.286 139.286 172.684 139.286 175.643Z",
    fill: "url(#paint85_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 175.643C171.429 178.602 169.03 181 166.071 181C163.113 181 160.714 178.602 160.714 175.643C160.714 172.684 163.113 170.286 166.071 170.286C169.03 170.286 171.429 172.684 171.429 175.643Z",
    fill: "url(#paint86_linear_809_54997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.571 175.643C203.571 178.602 201.173 181 198.214 181C195.256 181 192.857 178.602 192.857 175.643C192.857 172.684 195.256 170.286 198.214 170.286C201.173 170.286 203.571 172.684 203.571 175.643Z",
    fill: "url(#paint87_linear_809_54997)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_809_54997",
    x1: 185,
    y1: 210,
    x2: 65.5,
    y2: -94.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOrnament);
export default __webpack_public_path__ + "static/media/profile-ornament.95e0ddac5cc89d331d30c4e1bf494dc9.svg";
export { ForwardRef as ReactComponent };